import isEqual from "lodash.isequal";

import { createSelector } from "@reduxjs/toolkit";
import type { RootState } from "@src/store/rootState";
import { getAnalyticsProducts } from "@src/store/slices/analyticsProducts";

export const getUnsavedAnalyticsProducts = createSelector(
  getAnalyticsProducts,
  (state: RootState) => state.analyticsProducts.storedAnalyticsProducts,
  (analyticsProducts, storedAnalyticsProducts) => {
    return !isEqual(analyticsProducts, storedAnalyticsProducts)
      ? analyticsProducts
      : undefined;
  }
);
